import Close from "../../../assets/images/icons/close.svg";
import { Images } from "../../Common/Images";
import guestConfirmation from "../../../assets/images/icons/GuestConformation.svg";

const GuestBookingConfirmationModal = ({
    t,
    guestBookingConfirmation,
    closeGuestBookingConfirmation,
    formatDateToEEEddMMM,
}) => {
    return (
        <div className="modal" style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}>
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                <div className="modal-content modal-radius">
                    <div className="modal-body">
                        <div className="close-modal">
                            <a className="close-modal">
                                <img src={Close} alt="Close" onClick={closeGuestBookingConfirmation} />
                            </a>
                        </div>
                        <div className="pt-4">
                            <h5 className="popup-title">{t("your_booking_is_confirmed")}</h5>
                        </div>
                        <div className="divider-line mt-3"></div>
                        <div className="modal-des">
                            <div>
                                <div className="icon-with-list mb-3">
                                    <div className="icon-wrap">
                                        <img src={Images.Participant} alt="" />
                                        <h4>{guestBookingConfirmation.name} ({t("guest")})</h4>
                                    </div>
                                    <div className="icon-wrap">
                                        <img src={Images.CalendarMenu} alt="repeat" />
                                        <h4>{formatDateToEEEddMMM(guestBookingConfirmation.bookedDate)}</h4>
                                    </div>
                                    <div className="icon-wrap align-items-start">
                                        <img className="pt-1" src={Images.ZoneMap} alt="map" />
                                        <h4>
                                            {guestBookingConfirmation.zoneName}
                                            <span className="d-block">{guestBookingConfirmation.spotName}</span>
                                        </h4>
                                    </div>
                                    <div className="text-center mt-5 mb-2">
                                        <img src={guestConfirmation} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuestBookingConfirmationModal;
